import { postRequest } from "../utils/fetch";

const basePath = "/ApiCore/UploadApi";

export interface IUploadResult {
	readonly success: boolean;
	readonly file: File;
}

export enum ImportStatus {
	Waiting = 0,
	Imported = 1,
	Failed = 2,
	NotFound = 3,
	LoggedOut = 4,
}

export interface IUploadSessionRequest {
	pointOfSaleId: string;
	folderId: string;
	flow: string;
	uploadTechnology: string;
	accountId: string;
}

export interface IUploadSessionResponse {
	readonly id: string;
	readonly folderId: string;
	readonly uploadUrl: string;
}

export interface IUploadSessionStatusRequest {
	sessionId: string;
	accountId: string;
}

export interface IUploadSessionStatus {
	readonly fileId: string;
	readonly status: ImportStatus;
	readonly info: string;
	readonly originalFileName: string;
}

export async function upload(path: string, file: File, config?: RequestInit): Promise<IUploadResult> {
	const formData = new FormData();
	formData.append("file", file);
	formData.append("fileName", file.name);

	const init = { method: "post", body: formData, ...config };
	const request = new Request(path.toLowerCase(), init);
	const response = await fetch(request);

	return { success: response.ok, file: file } as IUploadResult;
}

export function createUploadSessionAsync(
	folderId: string,
	flow: string,
	uploadTechnology: string,
	accountId: string,
): Promise<IUploadSessionResponse> {
	const request: IUploadSessionRequest = {
		pointOfSaleId: window.context.pointOfSaleId,
		folderId,
		flow,
		uploadTechnology,
		accountId,
	};

	return postRequest<IUploadSessionRequest, IUploadSessionResponse>(basePath + "/CreateUploadSession", request, {
		headers: new Headers({ "Content-type": "application/json; charset=utf-8" }),
	});
}

export function checkImportStatusForSessionAsync(
	sessionId: string,
	accountId: string,
): Promise<IUploadSessionStatus[]> {
	const request: IUploadSessionStatusRequest = {
		sessionId,
		accountId,
	};

	return postRequest<IUploadSessionStatusRequest, IUploadSessionStatus[]>(
		basePath + "/CheckImportStatusForSession",
		request,
		{ headers: new Headers({ "Content-type": "application/json; charset=utf-8" }) },
	);
}
